import { useCallback, useEffect, useState } from 'react';
import { rbacService } from '../services/rbacService';

const EMPTY_GUARD = {
  canDelete: false,
  assignedUsersCount: 0,
  assignedUsers: [],
};

export default function useProfileDeleteGuard(profileId, open) {
  const [guard, setGuard] = useState(EMPTY_GUARD);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!profileId) {
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const res = await rbacService.getDeleteGuard(profileId);
      if (!res.ok) {
        setGuard(EMPTY_GUARD);
        setError('Unable to verify profile assignments.');
        return;
      }

      const payload = res.data || {};
      setGuard({
        canDelete: Boolean(payload.can_delete),
        assignedUsersCount: payload.assigned_users_count ?? 0,
        assignedUsers: payload.assigned_users || [],
      });
    } catch {
      setGuard(EMPTY_GUARD);
      setError('Unable to verify profile assignments.');
    } finally {
      setIsLoading(false);
    }
  }, [profileId]);

  useEffect(() => {
    if (!open || !profileId) {
      setGuard(EMPTY_GUARD);
      setError('');
      setIsLoading(false);
      return;
    }

    load();
  }, [load, open, profileId]);

  return {
    guard,
    isLoading,
    error,
    reload: load,
  };
}
